import React from 'react';
import Coupon from '../Coupon';
import { useContainer } from '../StoreProvider';
import styled from './index.module.scss';
import { useLang } from '@/i18n';

const MyBonus = () => {
    const { t } = useLang('membersstore.bonus');
    const { priceInfo } = useContainer();

    const TotalValue = React.useMemo(() => {
        if (priceInfo && priceInfo?.subtotalPrice !== undefined) {
            return `${priceInfo?.currencySymbol}${priceInfo?.subtotalPrice}`;
        }
        return '-';
    }, [priceInfo]);

    const PendingValue = React.useMemo(() => {
        if (priceInfo && priceInfo?.pendingSubtotalPrice !== undefined) {
            return `${priceInfo?.currencySymbol}${priceInfo?.pendingSubtotalPrice}`;
        }
        return '-';
    }, [priceInfo]);

    return (
        <div className={styled.my_bonus}>
            <div className="content">
                <div className="rewards">
                    <div className="text">
                        <div className="ecocredits">
                            <p className="num">{TotalValue}</p>
                            <p className="desc">{t('total_spend')}</p>
                        </div>
                        <div className="ecocredits pending">
                            <p className="num">{PendingValue}</p>
                            <p className="desc">{t('pending')}</p>
                        </div>
                    </div>
                    {priceInfo && <Coupon receiveStatus={priceInfo.receiveStatus} useStatus={priceInfo?.useStatus} name={priceInfo.discountName} />}
                </div>
            </div>
        </div>
    );
};

export default MyBonus;
